import React, { useCallback } from 'react';
import { clientProfileRoutes, COMPONENT_TYPES, paymentRoutes } from '@atlas/routing';
import { SiteConfigManager } from '@atlas/core';

import { Link } from 'react-router-dom';

import { useLocalBetslip } from 'common/Betslip/LocalBetslipContext';
import { Label } from '@atlas/ui';

const { CLIENT_PROFILE } = COMPONENT_TYPES;

const NoMoneyButton = ({ className }) => {
  const clientProfilePath = SiteConfigManager.getComponentPath(CLIENT_PROFILE);
  const { setIsOpenPopup: setIsBetslipOpen, setBetIdToEdit } = useLocalBetslip();

  const onGoToDeposit = useCallback(() => {
    setIsBetslipOpen(false);
    setBetIdToEdit(null);
  }, []);

  const link = `${clientProfilePath}/${clientProfileRoutes.payment}/${paymentRoutes.deposit}`;

  return (
    <Link className={className} onClick={onGoToDeposit} to={link}>
      <Label message="place_bet_deposit_redirect" />
    </Link>
  );
};

export default NoMoneyButton;
